module.exports = __webpack_public_path__ + "img/30.026da7df.jpg";